import React, {useState, useEffect} from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Switch,
  Card,
  Tabs,
  Popconfirm
} from "antd";
import * as Icon from "react-feather";
import mainContentService from "../../services/main-content-service";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import HtmlEditor from "../../components/input/html-editor";
import { FORM_LANG, formText, langOfTab } from "../../constants/form-i18n";
import mainContentPreviewAction from "../../redux/action/main-content-action";
import {PREVIEW_TYPE } from '../../constants/app-constants';
import { openWebsitePreview } from "../../utils/preview-utils";

const { TabPane } = Tabs;

const MainContent = () => {
  const dispatch = useDispatch();
  const [editorContentTH, setEditorContentTH] = useState('');
  const [editorContentEN, setEditorContentEN] = useState('');
  // NMU-444: only the tabbed editors are a "form" here — the page chrome around
  // them is not, so the tab language drives the editors and nothing else.
  const [lang, setLang] = useState(FORM_LANG.TH);
  const t = formText(lang);
  const [editorStatus, setEditorStatus] = useState(true);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    doSearch();
  }, []);

  const doSearch = async () => {
    try {
        dispatch(appLoaderAction.enable());

        const result = await mainContentService.search();
        setEditData(result.bean);
        setEditorContentTH(result.bean.content.contentTH);
        setEditorContentEN(result.bean.content.contentEN);
        setEditorStatus(result.bean.status);
        dispatch(appLoaderAction.disale());
    } catch (err) {
        dispatch(appLoaderAction.disale());
        dispatch(notifyUtitls.error(err));
    }
  };

  function getBean(){
    let bean = JSON.parse(JSON.stringify(editData));
    bean.content = {
      contentTH: editorContentTH,
      contentEN: editorContentEN
    }
    bean.status = editorStatus;

    return {bean:bean};
  }

  const onSave = async () => {
    try {
        try {
            dispatch(appLoaderAction.enable());

            // let bean = JSON.parse(JSON.stringify(editData));
            // bean.content = {
            //   contentTH: editorContentTH,
            //   contentEN: editorContentEN
            // }
            // bean.status = editorStatus;
            
            await mainContentService.edit(getBean());

            dispatch(appLoaderAction.disale());
            notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
            doSearch();
        } catch (err) {
            notifyUtitls.error(err);
            dispatch(appLoaderAction.disale());
        }
    } catch (errorInfo) {
        notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
    }
  };

  const onChangeValueTH = (value) => {
    setEditorContentTH(value);
  }

  const onChangeValueEN = (value) => {
    setEditorContentEN(value);
  }

  const onChangeValueStatus = (value) => {
    setEditorStatus(value);
  }

  const onPreview = async () => {
		try {
			dispatch(appLoaderAction.enable());

      // dispatch(mainContentPreviewAction.addMainContentPreview(getBean()));

      let previewBean = JSON.parse(JSON.stringify(editData));
      previewBean.content = {
        contentTH: editorContentTH,
        contentEN: editorContentEN
      }
      previewBean.status = editorStatus;

      await openWebsitePreview({ type: PREVIEW_TYPE.mainContent, bean: previewBean });
      dispatch(appLoaderAction.disale());
		} catch (err) {
			dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
		}
	}

  return (
    <div>
      <h2 className="color-primary-title">เนื้อหาหลัก</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>เนื้อหาหลัก</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
        <div className="d-flex justify-content-between">
          <Popconfirm
            title="ยืนยันการการบันทึกข้อมูล ?"
            onConfirm={() => onSave()}
            okText="ยืนยัน"
            cancelText="ยกเลิก" >
            <Button type="primary" >
              <Icon.Save className="me-1" size={18} /> บันทึกเนื้อหาหลัก
            </Button>
          </Popconfirm>
        <div>
          <span className="me-2">สถานะ</span>
          <Switch className="me-2" defaultChecked checked={editorStatus} onChange={onChangeValueStatus}/>
          <Button className="mx-2 btn-line" onClick={() => onPreview()}>
            <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
          </Button>
        </div>
       
      </div>
      <Card className="mt-4" bordered={false}>
        <div>
          <Tabs defaultActiveKey="1" onChange={(key) => setLang(langOfTab(key))}>
            <TabPane tab={t('tabThai')} key="1" forceRender>
              <HtmlEditor key="th" id="th" lang={lang} setContents={editorContentTH} onChange={onChangeValueTH}/>
            </TabPane>
            <TabPane tab={t('tabEnglish')} key="2" forceRender>
              <HtmlEditor key="en" id="en" lang={lang} setContents={editorContentEN} onChange={onChangeValueEN}/>
            </TabPane>
          </Tabs>
        </div>
      </Card>
    </div>
  );
};

export default MainContent;
